import * as React from "react";
import "./FormContainerInline.css";

interface IRowFormGroupProps {
    children: React.ReactNode;
}

export const RowFormGroup = (props: IRowFormGroupProps) => {
    if (!props.children) {
        return null;
    }
    return (
        <tr className="row">
            <td className={"col-sm-12"}>
                {props.children}
            </td>
        </tr>
    );
}

export interface IFormContainerInlineProps {
    elements: JSX.Element[];
    onDelete?: () => void;
}

export const FormContainerInline = (props: IFormContainerInlineProps) => {
    return (
        <div className="table form-container-inline col-sm-12">
            <table>
                <tbody>
                    {
                        props.elements.map((elem, index) => <RowFormGroup key={"form-container-inline-" + index}>{elem}</RowFormGroup>)
                    }
                </tbody>
            </table>
            {
                props.onDelete &&
                <div className="delete">
                    <span onClick={props.onDelete}><i className="fas fa-times" /></span>
                </div>
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/FormControls/FormContainerInline.tsx